import script from "./EmbarquesForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EmbarquesForm.vue?vue&type=script&setup=true&lang=js"

import "./EmbarquesForm.vue?vue&type=style&index=0&id=7945ee74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7945ee74"]])

export default __exports__